import { alpha, styled } from '@mui/material';

export const CartContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: 'fit-content',
  padding: '12px',
  margin: '6px 10px',
  transition: 'background-color 120ms ease',
  border: `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
  borderRadius: '14px',
  ':hover': {
    backgroundColor: alpha(theme.palette.text.primary, 0.04),
  },
  cursor: 'pointer',
}));

export const ContentWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  fontSize: '13px',
});

export const CartNameSpan = styled('span')(({ theme }) => ({
  fontWeight: 500,
  fontSize: '13px',
  color: theme.palette.text.primary,
}));

export const InfoRow = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  color: theme.palette.text.secondary,
  fontSize: '12px',
}));
